import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { WaiterMobileComponent } from './waiter-mobile.component';
import { IframeModule } from '../../shared/iframe/iframe.module';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  imports: [CommonModule, IframeModule, SharedModule, RouterModule],
  declarations: [WaiterMobileComponent],
  providers: []
})
export class WaiterMobileModule {}
